<template>
    <ul class="nav_breadcrumbs">
        <li>
            <router-link to="/modules/home">{{lang.LBL_HOME}}</router-link>
        </li>
        <li>
            <router-link to="/modules/workpackages/edit">{{lang.LBL_CREATE_WORK_PACKS}}</router-link>
        </li>
        <li>
            <router-link to="/modules/workpackages">{{lang.LBL_VIEW_WORK_PACK}}</router-link>
        </li>
    </ul>
</template>
<script>
    import lang from "@/views/modules/WorkPackages/language/en";
    export default {
        name: "breadcrumbs",
        data() {
            return {
                lang: [],
            }
        },
        mounted() {
            this.lang = lang;
        },

    }
</script>